import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FilterUtils } from 'primeng/components/utils/filterutils';
import 'rxjs/operator/map';
import { CommonSerivce } from '../shared/services/common.service';
import { UserService } from '../shared/services/user.service';
import { ConfirmationService } from 'primeng/api';
import { jsPDF } from "jspdf";
//import * as jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Observable } from 'rxjs/Observable';
//import 'jspdf-autotable';
//import jsPDF from 'jspdf';
//import 'jspdf-autotable';
import 'rxjs/Rx';
import * as XLSX from "xlsx-js-style";
import { Router } from '@angular/router';

import { IDialogApprovalAction, IDialogApprovalRoute, IReturnDialogApprovalAction, IReturnDialogApprovalRoute } from '../shared/models/shared.services.interface';
import { BcpApprovalRouteService } from '../shared/services/approvalRoute/bcpApprovalRoute.service';
import { BcpApprovalActionService } from '../shared/services/approvalAction/bcpApprovalAction.service';

@Component({
  selector: 'company',
  styleUrls: ['../shared/share.component.css'],
  providers: [CommonSerivce, UserService, DatePipe, ConfirmationService],
  templateUrl: './company.component.html'
})


export class CompanyComponent implements OnInit {

  /*
        RecordList - Search result list
        SelectedRecordList - User selected record (Multiple) in the result table
        SelectedRecord - User selected record (Single) for edition
  */
  public RecordList: ICompany[];
  public SelectedRecordList: ICompany[];
  public SelectedRecord: ICompany;

  public DocRecordList: ICompanyDoc[];
  public SelectedDocRecordList: ICompanyDoc[];
  public SelectedDocRecord: ICompanyDoc;

  public SelectedContactRecord: IContact;
  public SelectedUserRecord: IUserProfile;
  public SelectedAttachmentList: IAttachmentValue[];
  public SelectedAttachmentRecord: IAttachmentValue;
  public InputErrorMsg: Message[] = [];

  //  Hold the value of the user inputted search field, to be used for searching
  public SearchFieldHolder: any;
  public SearchDnFieldHolder: any;
  public cols: any;
  public companyDocCols: any;
  public exportColumns: any;
  public pdfColumns = [];
  public attachmentCols: any;

  //  Code value list for List Box, add required code value list
  public DomainList: IDomainValue[];
  public DataRoleList: IDataRole[];
  public ProcessRoleList: IProcessRole[];
  public AttachmentList: IAttachmentValue[];
  public CompanyTypeList: IListValue[];
  public TypeOfBusinessList: IListValue[];
  public TypeOfOwnershipList: IListValue[];
  public DocumentTypeList: IListValue[];

  public cId: number = 0;
  public CompanyDocDataSet: ICompanyDoc;

  public newContactId: any;
  public loggedInType: string = "";
  public loggedInCompanyCode: string = "";
  public confirmEmail: string = "";
  public currentVertificationKey: string = "";
  public currentRegisterFlag: string = "";
  public currentInviteFlag: string = "";
  public currentTempCompany: string = "";
  public currentCompanyStatus: string = "";
  public inputVerificationKey: string = "";

  public globalFilterValue1: string = "";
  public globalFilterValue2: string = "";
  public globalFilterValue3: string = "";
  public globalFilterValue4: string = "";

  //excel variable
  excelRow: string[] = [];
  strLine: string;
  cellList: string[];
  lastRowNumber: number;

  /*
    action code security
*/
  public allowAdd: string = "N";

  /*
        sort0 - define the sorting sequence for the table field (1 asc, 0 desc)
        softF - define the sorting field name
  */
  sortO: number = 0;
  sortF: string = '';


  /*
        Major control variables
            FormTitle - Initial Form Title for the landing form
            PrimaryApiPath - Path for the API controller per component 
            ShowEditForm/ ShowAddForm - control whether to show Inquiry or Edit form
            AutoReload - control auto reload component    
  */
  FormTitle: String = "Work With Company Profile";
  FormAccessRight: String = "NA";
  PrimaryApiPath: string = "api/BcpCompany/";
  CompanyDocApiPath: string = "api/BcpCompanyDoc/";
  ContactApiPath: string = "api/BcpContact/";
  UserProfileApiPath: string = "api/BcpUserProfile/";
  ListValueApiPath: string = "api/BcpListValue/";
  TableSequenceApiPath: string = "api/BcpTableSequence/";
  AuthApiPath: string = "api/BcpJwtAuth/getDistinguishedName/";
  SendEmailPath: string = "api/BcpEmailService/";
  SecurityApiPath: string = "api/BcpUserSecurityAction/";
  AttachmentApiPathLocal: string = "api/BcpAttachment/";
  AttachmentApiPathAzure: string = "api/BcpAzureAttachment/";
  AttachmentApiPath: string = " ";
  
  ShowAddForm: Boolean = false;
  ShowEditForm: Boolean = false;
  ShowInquiryForm: Boolean = false;
  ShowDeclarationForm: Boolean = false;
  ShowNotAuthorizedForm: Boolean = false;
  ShowVerificationForm: Boolean = false;
  SuccessUpload: Boolean = false;
  AddMode: string = "N";
  AcceptDeclaration: Boolean = false;
  checkedError: string = "";
  newRecordId: any;

  AutoReload: Boolean = true;
  CompanyDocAutoReload: Boolean = true;

  scrollHeight: string = "";
  scrollWidth: string = "";

  public RecordCount: number = 0;

  httpOriginalUrl: String;
  stringifyValue = "";
  stringifyUploadValue = "";
  Headers = new HttpHeaders();
  isLoggedIn: boolean = false;
  doingRegistration: boolean = false;

  //Attachment related
  public uploadAttachment: boolean = false;
  public record: any;
  uploadFile: File;
  AttachmentAutoReload: Boolean = true;
  lineNumber: number = 0;
  minimumDate = new Date();
  dateFormat: String = "yy-mm-dd";

  public resultMsgs: Message[] = [];
  public emailReturnStatus: boolean = false;
  public companyRegistrationEmail: ICompanyRegistrationEmail;
  public CopyCompanyDocFieldHolder: ICopyCompanyDoc;
  public DeleteCompanyFieldHolder: IDeleteCompany;
  public GenNextNumberFieldHolder: IGenNextNumber;
  public NextNumberOutput: INextNumber;
  public CompanyStatus: ICompanyStatus;

  //For display Edit and Delete Images
  //public imgEdit = require("../shared/Images/edit.gif");
  //public imgDelete = require("../shared/Images/delete.gif");

  //for animation status
  //animStatus: string = 'inactive';


  constructor(private http: HttpClient, @Inject('BASE_URL') originUrl: string
  , private bcp: CommonSerivce, private datePipe: DatePipe
  , private confirmationService: ConfirmationService
    , private bcpApprovalRoute: BcpApprovalRouteService
    , private bcpApprovalAction: BcpApprovalActionService
  , private _router: Router) {
    //  this.httpHeaders = this.bcp.getHttpHeader();
    this.PrimaryApiPath = originUrl + this.PrimaryApiPath;
    this.CompanyDocApiPath = originUrl + this.CompanyDocApiPath;
    this.ContactApiPath = originUrl + this.ContactApiPath;
    this.UserProfileApiPath = originUrl + this.UserProfileApiPath;
    this.ListValueApiPath = originUrl + this.ListValueApiPath;
    this.TableSequenceApiPath = originUrl + this.TableSequenceApiPath;
    this.SendEmailPath = originUrl + this.SendEmailPath;
    this.SecurityApiPath = originUrl + this.SecurityApiPath;

    this.FormAccessRight = this.bcp.getAccessRightByProcess('COMPANY');
    this.isLoggedIn = this.bcp.getLoginStatus();

    this.loggedInType = this.bcp.getCurrentUserAccountType();
    this.loggedInCompanyCode = this.bcp.getCurrentCompanyCode();

    this.AttachmentApiPath = this.AttachmentApiPathLocal;
    if (this.bcp.getAttachmentTarget() == "AZURE") {
      this.AttachmentApiPath = this.AttachmentApiPathAzure;
    }
    this.AttachmentApiPath = originUrl + this.AttachmentApiPath;

    this.minimumDate.setDate(this.minimumDate.getDate() + 1);

    //get action security controls
    this.getSecurity();

    this.FormTitle = "Work With Company Profile";
    this.ShowInquiryForm = true;
    this.ShowAddForm = false;
    this.ShowEditForm = false;
    this.ShowDeclarationForm = false;
    this.ShowNotAuthorizedForm = false;
    this.ShowVerificationForm = false;

    this.getFirstPage();

    //get all list value for drop down list
    this.getListValue();
    this.getDomainList();

    //this.getCompanyStatus(this.bcp.getCurrentDomainId(), this.loggedInCompanyCode);

    this.resetSearchField();

    this.scrollHeight = this.bcp.getDataTableHeight(0);//parameter: # of rows used for header search field
    this.scrollWidth = this.bcp.getDataTableWidth();

    this.SelectedRecord = null;
    this.SelectedContactRecord = null;
    this.InputErrorMsg = [];


    this.cols = [
      { field: 'actions', header: 'Actions', width: '30', size: '5' },
      //{ field: 'id', header: 'ID', width: '80', size: '5' },
      { field: 'domainId', header: 'Domain ID', width: '50', size: '10' },
      { field: 'companyType', header: 'Company Type', width: '50', size: '10' },
      { field: 'companyCode', header: 'Company Code', width: '30', size: '10' },
      { field: 'companyNumber', header: 'Company No.', width: '30', size: '10' },
      { field: 'fullName', header: 'Company Name', width: '120', size: '10' },
      { field: 'companyStatus', header: 'Status', width: '40', size: '10' },
      { field: 'inviteFlag', header: 'Invited (Y/N)', width: '40', size: '10' },
      { field: 'registerFlag', header: 'Register (Y/N)', width: '40', size: '10' },
      { field: 'tempCompany', header: 'Temp (Y/N)', width: '40', size: '10' },
      //{ field: 'primaryContactId', header: 'Contact ID', width: '80', size: '5' },
    ];

    this.companyDocCols = [
      { field: 'select', header: ' ', width: '30', size: '5' },
      //{ field: 'id', header: 'ID', width: '80', size: '5' },
      //{ field: 'domainId', header: 'Domain ID', width: '140', size: '10' },
      { field: 'companyDocumentType', header: 'Doc Type', width: '60', size: '10' },
      { field: 'companyDocumentName', header: 'Document Name', width: '200', size: '10' },
      { field: 'applicableFlag', header: 'Applicable (Y/N)', width: '80', size: '10' },
      { field: 'documentNumber', header: 'Document Number', width: '100', size: '10' },
      { field: 'documentExpiryDate', header: 'Expiry Date', width: '100', size: '10' },
      { field: 'upload', header: 'Upload', width: '90', size: '5' },
      { field: 'displayName', header: 'File Name', width: '160', size: '5' },
      { field: 'mandatoryFlag', header: 'Mandatory (Y/N)', width: '80', size: '10' },
      { field: 'actions', header: 'Actions', width: '60', size: '5' },
      //{ field: 'primaryContactId', header: 'Contact ID', width: '80', size: '5' },
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));
    this.pdfColumns[0] = Object.values(this.cols.map(e => Object.keys(e).map(k => e[k]))).map(item => item[0]);

    this.attachmentCols = [
      { field: 'actions', header: 'Actions', width: '60', size: '5' },
      { field: 'id', header: 'Id', width: '60', size: '5' },
      { field: 'sourceRecordId', header: 'Source Record Id', width: '100', size: '5' },
      { field: 'displayName', header: 'File Name', width: '100', size: '5' },
      { field: 'createDate', header: 'Create Date', width: '100', size: '5' }
    ];

  }

  ngOnInit() {

    FilterUtils['custom'] = (value, filter): boolean => {
      if (filter === undefined || filter === null || filter.trim() === '') {
        return true;
      }

      if (value === undefined || value === null) {
        return false;
      }

      return parseInt(filter) > value;
    };

   }

  //-----------------------------------------------------------------------------
  //                            Fetch/ Search Data
  //-----------------------------------------------------------------------------


  //to get required code list
  getListValue() {
    //get list value for company type dropdown
    this.http.get(this.ListValueApiPath + "ByListCode2/" + "BCP" + "/CO_TYPE", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.CompanyTypeList = result;
      });
  }

  //to get required code list
  getListValueByDomain(selectedDomain) {
    //get list value for type of business dropdown
    this.http.get(this.ListValueApiPath + "ByListCode2/" + selectedDomain + "/TYPE_OF_BIZ", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.TypeOfBusinessList = result;
      });

    //get list value for type of ownership dropdown
    this.http.get(this.ListValueApiPath + "ByListCode3/" + selectedDomain + "/TYPE_OF_OWN", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.TypeOfOwnershipList = result;
      });

    //get list value for company document type
    this.http.get(this.ListValueApiPath + "ByListCode2/" + selectedDomain + "/CO_DOC_TYPE", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.DocumentTypeList = result;
      });
  }


  async getSecurity() {
    //check for tender master creation
    let checkResult1 = await this.http.get(this.SecurityApiPath + "CheckActionSecurity/" + this.bcp.getCurrentDomainId() + "/" + this.bcp.getCurrentActionRole() + "/COM1", this.bcp.getHttpOptions())
      .map((response: any) => JSON.parse(response.toString())).toPromise();
    if (checkResult1.allowAccess == "Y") {
      this.allowAdd = "Y";
    }
  }

  //determine what the first page should be shown
  async getFirstPage() {
    if (this.loggedInType == 'B') {
      this.getData();
    }
    else if (this.loggedInType == 'D') {
      this.getDataByType();
    }
    else if (this.loggedInType == 'E') {
      await this.getCompanyStatus(this.bcp.getCurrentDomainId(), this.loggedInCompanyCode);
      this.ShowInquiryForm = false;
      if (this.currentInviteFlag == "Y" && this.currentTempCompany == "N") {
        this.FormTitle = "Registration Declaration";
        this.ShowDeclarationForm = true;
        this.ShowNotAuthorizedForm = false;
      } else {
        this.FormTitle = "Company Registration";
        this.ShowDeclarationForm = false;
        this.ShowNotAuthorizedForm = true;
      }
    };
  }

  //get initial data by Domain for Inquiry
  getData() {
    this.AutoReload = true;
    this.http.get(this.PrimaryApiPath + "GetByDomain/" + this.bcp.getCurrentDomainId(), this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.RecordList = result;
        this.RecordCount = this.RecordList.length;
        console.log("Record List:"+this.RecordList);

        if (this.RecordList.length > 0) {
          for (var i = 0; i < this.RecordList.length; i++) {
            this.applyGlobalFilter();
            //Stop Loading Icon when finish fetching last record
            if (i == this.RecordCount) {
              //this.AutoReload = false;
            }
          }
        } else {
          this.RecordList = null;
          //this.AutoReload = false;
        }

      });
  }

  //get company status fields
  async getCompanyStatus(domainId, companyCode) {
    this.CompanyStatus = await this.http.get(this.PrimaryApiPath + "GetCompanyStatus/" + domainId + "/" + companyCode, this.bcp.getHttpOptions())
      .map((response: any) => response).toPromise();
    this.currentVertificationKey = this.CompanyStatus.vertificationKey;
    this.currentRegisterFlag = this.CompanyStatus.registerFlag;
    this.currentInviteFlag = this.CompanyStatus.inviteFlag;
    this.currentTempCompany = this.CompanyStatus.tempCompany;
    this.currentCompanyStatus = this.CompanyStatus.companyStatus;
    //console.log("Invite Flag is " + this.currentInviteFlag);
    //console.log("Temp Company is " + this.currentTempCompany);
    console.log("Vertification is " + this.currentVertificationKey);
  } GetDataByDomainTypeE

  //get initial data by Domain and Company Type for Inquiry
  getDataByType() {
    this.AutoReload = true;
    this.http.get(this.PrimaryApiPath + "GetByDomainTypeE/" + this.bcp.getCurrentDomainId(), this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.RecordList = result;
        this.RecordCount = this.RecordList.length;
        //console.log(this.RecordList);

        if (this.RecordList.length > 0) {
          for (var i = 0; i < this.RecordList.length; i++) {
            this.applyGlobalFilter();
            //Stop Loading Icon when finish fetching last record
            if (i == this.RecordCount) {
              //this.AutoReload = false;
            }
          }
        } else {
          this.RecordList = null;
          //this.AutoReload = false;
        }

      });
  }

  //get record by id and assign to selected record
  getDataById(id) {
    this.http.get(this.PrimaryApiPath + id, this.bcp.getHttpOptions())
      .subscribe((data: any) => {
        this.SelectedRecord = data;
        this.SelectedRecord.tempCompany = this.bcp.convertYesNoToBoolean(this.SelectedRecord.tempCompany);
        this.SelectedRecord.inviteDate = this.bcp.convertDateTimetoDate(this.SelectedRecord.inviteDate);
        this.SelectedRecord.registerDate = this.bcp.convertDateTimetoDate(this.SelectedRecord.registerDate);
        this.SelectedRecord.approveDate = this.bcp.convertDateTimetoDate(this.SelectedRecord.approveDate);
        //this.getListValueByDomain(this.SelectedRecord.domainId);
        this.getListValueByDomain("TSML");
        this.SelectedContactRecord = null;
        this.addContactRecord();
        this.addUserProfileRecord();
        this.getContactDataByCompanyCode(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, "P");
        this.getCompanyDocData();
      });
  }

  //get record by id and assign to selected record
  getDataBySearchField() {
    this.AutoReload = true;
    this.stringifyValue = JSON.stringify(this.SearchFieldHolder);
    //console.log("get data by search : " + this.stringifyValue);

    this.http.post(this.PrimaryApiPath + "q", this.stringifyValue, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.RecordList = result;
        //console.log(this.RecordList);
        if (this.RecordList.length > 0) {
          this.applyGlobalFilter();
          for (var i = 0; i < this.RecordList.length; i++) {
            //Stop Loading Icon when finish fetching last record
            if (i == this.RecordCount) {
              //this.AutoReload = false;
            }
          }
        } else {
          this.RecordList = null;
          //this.AutoReload = false;
        }


      });

  }

  //get record ID for re-direct to edit page 
  getIDbyData(domainId, companyCode) {
    this.http.get(this.PrimaryApiPath + "GetID/" + domainId + "/" + companyCode, this.bcp.getHttpOptions())
      .subscribe((data: any) => {
        this.record = data;
        this.editRecord(this.record.id);
      });
  
  }

  //get contact & user profile record by company code and assign to selected record
  getContactDataByCompanyCode(companyDomain, companyCode, primaryContact) {
    this.http.get(this.ContactApiPath + "byCompanyCode/" + companyDomain + "/" + companyCode + "/" + primaryContact, this.bcp.getHttpOptions())
      .subscribe((data: any) => {
        this.SelectedContactRecord = data;
        this.SelectedContactRecord.conflictOfInterest = this.bcp.convertYesNoToBoolean(this.SelectedContactRecord.conflictOfInterest);
        this.SelectedContactRecord.needUserAccount = this.bcp.convertYesNoToBoolean(this.SelectedContactRecord.needUserAccount);
        this.confirmEmail = this.SelectedContactRecord.email1;
        //get user profile record
        this.http.get(this.UserProfileApiPath + "GetByLoginId/" + this.SelectedRecord.domainId + "/" + this.SelectedContactRecord.loginId, this.bcp.getHttpOptions())
          .subscribe((result: any) => {
            this.SelectedUserRecord = result;
          });
      });

  }

  //get company doc record
  getCompanyDocData() {
    this.http.get(this.CompanyDocApiPath + "GetCompanyDoc/" + this.SelectedRecord.domainId + "/" + this.SelectedRecord.companyCode, this.bcp.getHttpOptions())
      .subscribe((result: any) => {
        this.DocRecordList = result;
        this.lineNumber = 0;
        if (this.DocRecordList.length > 0) {
          for (var i = 0; i < this.DocRecordList.length; i++) {
            this.lineNumber = this.DocRecordList[i].lineNumber;
            this.DocRecordList[i].documentExpiryDate = this.bcp.convertDateTimetoDate(this.DocRecordList[i].documentExpiryDate);
          }
        } else {
          this.DocRecordList = [{
            companyDocumentType: "", companyDocumentName: "", applicableFlag: "N", documentNumber: "",
            documentExpiryDate: "", displayName: "", mandatoryFlag: "N", id: 0, lineNumber: 1, attachmentRecordId: 0
          }];
          this.lineNumber = 1;
        }
      });

  }

  getCompanyDocumentName(domainId: string, docType: string, indexNumber: number) {
    this.http.get(this.ListValueApiPath + "getDescbyCode/" + domainId + "/CO_DOC_TYPE/" + docType, this.bcp.getHttpOptions())
      .subscribe((result: any) => {
        this.DocRecordList[indexNumber].companyDocumentName = result.replace(/"/g,"");
      });
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.RecordList);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "primengTable");
    });

  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);

    });
  } 

  exportPdf() {
    const doc = new jsPDF({ orientation: "landscape" });
    var head = [];
    head[0] = Object.values(this.cols.map(e => Object.keys(e).map(k => e[k]))).map(item => item[0]);
    autoTable(doc, {
      headStyles: { fillColor: [0,0,0] },
      styles: { fillColor: [255, 255, 0] },
      columnStyles: { 0: { halign: 'center', fillColor: [0, 255, 0] }, 1: { halign: 'left', fillColor: [0, 255, 255] } },
      head: head,
      body: this.RecordList.map(e => Object.keys(e).map(k => e[k])),
      didDrawCell: (data) => {
      },
    });

    doc.save('table.pdf');
  }

  findRecord() {
    this.RecordList = null;
    this.getDataBySearchField();
  }

  resetSearchField() {
    //dummy field, not use for searching
    this.SearchFieldHolder = JSON.parse('{"id": 0}');

    //set default value for all search fields
    //available field, please refer to the last part of [TableName]Controller.cs
    this.SearchFieldHolder["domainId"] = this.bcp.getCurrentDomainId();
    this.SearchFieldHolder["companyType"] = "";
    if (this.loggedInType == "D") {
      this.SearchFieldHolder["companyType"] = "E";
    };

  }

  clearGlobalFilter() {
    this.globalFilterValue1 = "";
    this.globalFilterValue2 = "";
    this.globalFilterValue3 = "";
    this.globalFilterValue4 = "";
  }

  applyGlobalFilter() {
    var element = document.getElementById('globalFilter1');
    var event = new Event('input');

    element = document.getElementById('globalFilter1');
    element.dispatchEvent(event);

    element = document.getElementById('globalFilter2');
    element.dispatchEvent(event);

    element = document.getElementById('globalFilter3');
    element.dispatchEvent(event);

    element = document.getElementById('globalFilter4');
    element.dispatchEvent(event);
  }


  //-----------------------------------------------------------------------------
  //                      Add/Edit/Save/Delete Records
  //-----------------------------------------------------------------------------


  addRecord() {
    //initialize the SelectedRecord as a new record, and assign default value as required
    this.SelectedRecord = null;
    this.SelectedRecord = JSON.parse('{"id": 0}');
    //set default value 
    this.SelectedRecord.domainId = "";
    this.SelectedRecord.companyCode = "";
    this.SelectedRecord.fullName = "";
    this.SelectedRecord.fullNameOther = "";
    this.SelectedRecord.fullNameCompress = "";
    this.SelectedRecord.companyNumber = 0;
    this.SelectedRecord.companyCodeOther = "";
    this.SelectedRecord.companyType = "";
    this.SelectedRecord.companyStatus = "OPEN";
    this.SelectedRecord.businessUnit = "";
    this.SelectedRecord.vertificationKey = "";
    this.SelectedRecord.inviteFlag = "N";
    this.SelectedRecord.registerFlag = "N";
    this.SelectedRecord.tempCompany = "N";
    this.SelectedRecord.typeOfBusiness = "";
    this.SelectedRecord.addressLine1 = "";
    this.SelectedRecord.addressLine2 = "";
    this.SelectedRecord.addressLine3 = "";
    this.SelectedRecord.addressLine4 = "";
    this.SelectedRecord.postalCode = "";
    this.SelectedRecord.country = "";
    this.SelectedRecord.typeOfOwnership = "";
    this.SelectedRecord.phoneArea1 = "";
    this.SelectedRecord.phone1 = "";
    this.SelectedRecord.phoneArea2 = "";
    this.SelectedRecord.phone2 = "";
    this.SelectedRecord.phoneArea3 = "";
    this.SelectedRecord.phone3 = "";
    this.SelectedRecord.phoneArea4 = "";
    this.SelectedRecord.phone4 = "";
    this.SelectedRecord.companyUrl = "";
    this.SelectedRecord.companyDomain = "";
    this.SelectedRecord.primaryContactId = "";
    this.SelectedRecord.maxUsers = 3;
    this.SelectedRecord.conflictOfInterest = "";
    this.SelectedRecord.conflictFullName = "";
    this.SelectedRecord.conflictDepartment = "";
    this.SelectedRecord.conflictRelationship = "";
    this.SelectedRecord.remark = "";
    this.SelectedRecord.controlFlag01 = "";
    this.SelectedRecord.controlFlag02 = "";
    this.SelectedRecord.controlFlag03 = "";
    this.SelectedRecord.fiscalDatePattern = "";
    this.SelectedRecord.currentYearGL = 0;
    this.SelectedRecord.currentPeriodGL = 0;
    this.SelectedRecord.currentYearAR = 0;
    this.SelectedRecord.currentPeriodAR = 0;
    this.SelectedRecord.currentYearAP = 0;
    this.SelectedRecord.currentPeriodAP = 0;
    this.SelectedRecord.createUser = this.bcp.getCurrentLoginUser();
    this.SelectedRecord.createDate = this.bcp.getCurrentDateTime();
    this.SelectedRecord.inviteUser = "";
    this.SelectedRecord.inviteDate = this.bcp.get1900Date();
    this.SelectedRecord.registerUser = "";
    this.SelectedRecord.registerDate = this.bcp.get1900Date();
    this.SelectedRecord.approveUser = "";
    this.SelectedRecord.approveDate = this.bcp.get1900Date();
    this.SelectedRecord.updateUser = "";
    this.SelectedRecord.updateDate = "";
    //convert to boolean
    this.SelectedRecord.tempCompany = this.bcp.convertYesNoToBoolean(this.SelectedRecord.tempCompany);
    //reset variable
    this.confirmEmail = "";
    //generate vertification code
    this.keyGen(4);
    //generate first blank line
    this.DocRecordList = [{
      companyDocumentType: "", companyDocumentName: "", applicableFlag: "N", documentNumber: "",
      documentExpiryDate: "", displayName: "", mandatoryFlag: "N", id: 0, lineNumber: 1, attachmentRecordId: 0,
      createUser: this.bcp.getCurrentLoginUser(), createDate: this.bcp.getCurrentDateTime()
    }];
    this.lineNumber = 1;
    //setup program flow control
    this.FormTitle = "Company Profile Revision";
    this.ShowAddForm = true;
    this.ShowEditForm = false;
    this.ShowInquiryForm = false;
    this.ShowDeclarationForm = false;
    this.ShowNotAuthorizedForm = false;
    this.ShowVerificationForm = false;
    this.AddMode = "Y";
    if (this.loggedInType == "D") {
      this.SelectedRecord.domainId = this.bcp.getCurrentDomainId();
      this.SelectedRecord.companyType = "E";
      this.FormTitle = "Company Code Revision";
    }
    //add for company doc record
    this.addCompanyDocRecord();
    //add for contact record
    this.addContactRecord();
    //add for user profile record
    this.addUserProfileRecord();
  }


  addCompanyDocRecord() {
    //initialize the SelectedDocRecord as a new record, and assign default value as required
    this.SelectedDocRecord = null;
    this.SelectedDocRecord = JSON.parse('{"id": 0}');
    //set default value 
    this.SelectedDocRecord.domainId = "";
    this.SelectedDocRecord.companyCode = "";
    this.SelectedDocRecord.lineNumber = "";
    this.SelectedDocRecord.companyDocumentType = "";
    this.SelectedDocRecord.companyDocumentName = "";
    this.SelectedDocRecord.applicableFlag = "N";
    this.SelectedDocRecord.documentNumber = "";
    this.SelectedDocRecord.documentReference = "";
    this.SelectedDocRecord.documentIssueDate = this.bcp.get1900Date();
    this.SelectedDocRecord.documentExpiryDate = this.bcp.get1900Date();
    this.SelectedDocRecord.remark = "";
    this.SelectedDocRecord.instructionText = "";
    this.SelectedDocRecord.mandatoryFlag = "";
    this.SelectedDocRecord.displaySequence = 0;
    this.SelectedDocRecord.controlFlag01 = "";
    this.SelectedDocRecord.controlFlag02 = "";
    this.SelectedDocRecord.controlFlag03 = "";
    this.SelectedDocRecord.createUser = this.bcp.getCurrentLoginUser();
    this.SelectedDocRecord.createDate = this.bcp.getCurrentDateTime();
    this.SelectedDocRecord.uploadUser = "";
    this.SelectedDocRecord.uploadDate = this.bcp.get1900Date();
    this.SelectedDocRecord.downloadUser = "";
    this.SelectedDocRecord.downloadDate = this.bcp.get1900Date();
    this.SelectedDocRecord.updateDate = "";
    this.SelectedDocRecord.updateUser = "";
  }


  addContactRecord() {
    //initialize the SelectedContactRecord as a new record, and assign default value as required
    this.SelectedContactRecord = null;
    this.SelectedContactRecord = JSON.parse('{"id": 0}');
    //set default value 
    this.SelectedContactRecord.domainId = "";
    this.SelectedContactRecord.contactId = "";
    this.SelectedContactRecord.companyCode = "";
    this.SelectedContactRecord.fullName = "";
    this.SelectedContactRecord.fullNameOther = "";
    this.SelectedContactRecord.businessUnit = "";
    this.SelectedContactRecord.title = "";
    this.SelectedContactRecord.department = "";
    this.SelectedContactRecord.addressLine1 = "";
    this.SelectedContactRecord.addressLine2 = "";
    this.SelectedContactRecord.addressLine3 = "";
    this.SelectedContactRecord.addressLine4 = "";
    this.SelectedContactRecord.postalCode = "";
    this.SelectedContactRecord.country = "";
    this.SelectedContactRecord.email1 = "";
    this.SelectedContactRecord.email2 = "";
    this.SelectedContactRecord.phoneArea1 = "";
    this.SelectedContactRecord.phone1 = "";
    this.SelectedContactRecord.phoneArea2 = "";
    this.SelectedContactRecord.phone2 = "";
    this.SelectedContactRecord.phoneArea3 = "";
    this.SelectedContactRecord.phone3 = "";
    this.SelectedContactRecord.phoneArea4 = "";
    this.SelectedContactRecord.phone4 = "";
    this.SelectedContactRecord.contactType = "";
    this.SelectedContactRecord.needUserAccount = "Y";
    this.SelectedContactRecord.userAccountType = "";
    this.SelectedContactRecord.activeFlag = "Y";
    this.SelectedContactRecord.primaryContact = "";
    this.SelectedContactRecord.loginId = "";
    this.SelectedContactRecord.conflictOfInterest = "";
    this.SelectedContactRecord.conflictFullName = "";
    this.SelectedContactRecord.conflictDepartment = "";
    this.SelectedContactRecord.conflictRelationship = "";
    this.SelectedContactRecord.createUser = this.bcp.getCurrentLoginUser();
    this.SelectedContactRecord.createDate = this.bcp.getCurrentDateTime();
    this.SelectedContactRecord.updateUser = "";
    this.SelectedContactRecord.updateDate = "";
  }


  addUserProfileRecord() {
    //initialize the SelectedUserRecord as a new record, and assign default value as required
    this.SelectedUserRecord = null;
    this.SelectedUserRecord = JSON.parse('{"id": 0}');
    //set default value 
    this.SelectedUserRecord.domainId = "";
    this.SelectedUserRecord.loginId = "";
    this.SelectedUserRecord.password = "";
    this.SelectedUserRecord.distinguishedName = "";
    this.SelectedUserRecord.fullName = "";
    this.SelectedUserRecord.department = "";
    this.SelectedUserRecord.title = "";
    this.SelectedUserRecord.email = "";
    this.SelectedUserRecord.phone = "";
    this.SelectedUserRecord.vip = "";
    this.SelectedUserRecord.processRole = "DEFAULT";
    this.SelectedUserRecord.dataRole = "ALL";
    this.SelectedUserRecord.actionRole = "DEFAULT";
    this.SelectedUserRecord.alphaName = "";
    this.SelectedUserRecord.errorAttempt = 0;
    this.SelectedUserRecord.businessUnit = "";
    this.SelectedUserRecord.controlFlag01 = "";
    this.SelectedUserRecord.controlFlag02 = "";
    this.SelectedUserRecord.controlFlag03 = "";
    this.SelectedUserRecord.companyCode = "";
    this.SelectedUserRecord.companyDomain = "";
    this.SelectedUserRecord.userId = "";
    this.SelectedUserRecord.accountType = "";
    this.SelectedUserRecord.staffNumber = "";
    this.SelectedUserRecord.company = "";
    this.SelectedUserRecord.team = "";
    this.SelectedUserRecord.grading = "";
    this.SelectedUserRecord.jdeAn81 = 0;
    this.SelectedUserRecord.jdeAn82 = 0;
    this.SelectedUserRecord.jdeAn83 = 0;
    this.SelectedUserRecord.jdeAn84 = 0;
    this.SelectedUserRecord.verifyCode = "";
    this.SelectedUserRecord.activeFlag = "Y";
    this.SelectedUserRecord.createUser = this.bcp.getCurrentLoginUser();
    this.SelectedUserRecord.createDate = this.bcp.getCurrentDateTime();
    this.SelectedUserRecord.updateUser = "";
    this.SelectedUserRecord.updateDate = "";
  }


  editRecord(recordId) {
    this.SelectedRecord = null;
    this.DocRecordList = null;
    this.SelectedDocRecordList = null;
    this.doingRegistration = false;
    this.getDataById(recordId);
    //this.getAttachmentList(recordId);

    this.FormTitle = "Company Profile Revision";// - ID = " + recordId;
    this.ShowAddForm = false;
    this.ShowEditForm = true;
    this.ShowInquiryForm = false;
    this.ShowDeclarationForm = false;
    this.ShowNotAuthorizedForm = false;
    this.ShowVerificationForm = false;
    this.AddMode = "N";

    //console.log("selected record is " + recordId);
    //console.log("selected contact id is " + this.SelectedContactRecord.id);
    //console.log("selected id is " + this.SelectedRecord.id);

  }


  async saveRecord() {
    if (this.SelectedRecord.companyType != "E") {
      this.SelectedRecord.companyStatus = "ACTIVE";
      this.SelectedRecord.inviteFlag = "Y";
      this.SelectedRecord.registerFlag = "Y";
      this.SelectedRecord.maxUsers = 99;
      this.SelectedRecord.registerUser = this.bcp.getCurrentLoginUser();
      this.SelectedRecord.registerDate = this.bcp.getCurrentDateTime();
      this.SelectedRecord.inviteUser = this.SelectedRecord.registerUser;
      this.SelectedRecord.inviteDate = this.SelectedRecord.registerDate;
      this.SelectedRecord.approveUser = this.SelectedRecord.registerUser;
      this.SelectedRecord.approveDate = this.SelectedRecord.registerDate;
    }
    this.SelectedRecord.companyCode = this.bcp.upper(this.SelectedRecord.companyCode);
    //save contact record firstly and get primaryContactId
    await this.saveContactRecord();
    this.newContactId = await this.http.get(this.ContactApiPath + "GetPrimaryID/" + this.SelectedRecord.domainId + "/" + this.SelectedRecord.companyCode, this.bcp.getHttpOptions()).toPromise();
    this.SelectedRecord.primaryContactId = this.newContactId;
    //save company record
    if (this.SelectedRecord.id == 0) {
      if (this.SelectedRecord.tempCompany != "Y" && this.SelectedRecord.tempCompany != true) {
        this.SelectedRecord.inviteFlag = "Y";
        this.SelectedRecord.inviteUser = this.bcp.getCurrentLoginUser();
        this.SelectedRecord.inviteDate = this.bcp.getCurrentDateTime();
      }
      this.stringifyValue = JSON.stringify(this.SelectedRecord);
      //console.log("ready to put1  " + this.stringifyValue);
      this.http.post(this.PrimaryApiPath, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          async (result: any) => {
            //send email to supplier
            let checkResult = await this.http.get(this.SecurityApiPath + "CheckApplyEmail/" + this.bcp.getCurrentDomainId() + "/COM1", this.bcp.getHttpOptions())
              .map((response: any) => JSON.parse(response.toString())).toPromise();
            if (checkResult.applyEmail == "Y") {
              if (this.SelectedRecord.tempCompany == "Y"
                || this.SelectedRecord.tempCompany == true) {
                console.log("no email");
              } else {
                console.log("prepare to send normal email");
                this.sendInviteRegistrationEmail();
              }
            }
            this.ShowAddForm = false;
            this.ShowEditForm = false;
            this.ShowInquiryForm = true;
            this.ShowDeclarationForm = false;
            this.ShowNotAuthorizedForm = false;
            this.ShowVerificationForm = false;
            this.FormTitle = "Work With Company Profiles";
            if (this.loggedInType!="E") {
              this.findRecord();
            }
            //if (this.uploadAttachment == true) {
              //this.getIDbyData()
            //} else {
            //  this.ShowAddForm = false;
            //  this.ShowEditForm = false;
            //  this.ShowInquiryForm = true;
            //  this.ShowDeclarationForm = false;
            //  this.ShowNotAuthorizedForm = false;
            //  this.ShowVerificationForm = false;
            //  this.FormTitle = "Work With Company Profiles";
            //  this.findRecord();
            //}
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }
          });
    }
    else {
      this.stringifyValue = JSON.stringify(this.SelectedRecord);
      //console.log("ready to put2  " + this.stringifyValue);
      this.http.put(this.PrimaryApiPath + "" + this.SelectedRecord.id, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          async (result: any) => {
            if (this.doingRegistration) {
              //send email to create user
              let checkResult = await this.http.get(this.SecurityApiPath + "CheckApplyEmail/" + this.bcp.getCurrentDomainId() + "/COM5", this.bcp.getHttpOptions())
                .map((response: any) => JSON.parse(response.toString())).toPromise();
              if (checkResult.applyEmail == "Y") {
                this.sendCompleteRegistrationEmail();
              }
            }
            this.ShowAddForm = false;
            this.ShowEditForm = false;
            this.ShowInquiryForm = true;
            this.ShowDeclarationForm = false;
            this.ShowNotAuthorizedForm = false;
            this.ShowVerificationForm = false;
            this.FormTitle = "Work With Company Profiles";
            if (this.loggedInType != "E") {
              this.findRecord();
            }
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }
          });
    }

    //save user profile record
    this.saveUserProfileRecord();

    //save company doc record
    if (this.SelectedRecord.id == 0 && this.SelectedRecord.companyType == "E") {
      this.CopyCompanyDocFieldHolder = null;
      this.CopyCompanyDocFieldHolder = JSON.parse('{"id": 0}');
      this.CopyCompanyDocFieldHolder.domainId = this.SelectedRecord.domainId;
      this.CopyCompanyDocFieldHolder.fromCompanyCode = this.SelectedRecord.domainId;
      this.CopyCompanyDocFieldHolder.toCompanyCode = this.SelectedRecord.companyCode;
      this.CopyCompanyDocFieldHolder.createUser = this.bcp.getCurrentLoginUser();
      this.CopyCompanyDocFieldHolder.createDate = this.bcp.getCurrentDateTime();
      this.stringifyValue = JSON.stringify(this.CopyCompanyDocFieldHolder);
      this.http.post(this.CompanyDocApiPath + "CopyCompanyDoc/", this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe((result: any[]) => {
          //do nothing
        });
    } else {
      this.processCompanyDocTable();
    }

  }


  saveCompanyDocRecord() {
    this.stringifyValue = JSON.stringify(this.SelectedDocRecord);
    //console.log("CompanyDocRecord is "+ this.stringifyValue);
    if (this.SelectedDocRecord.id == 0) {
      this.http.post(this.CompanyDocApiPath, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            //this.getCompanyDocData();
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }
          });
    }
    else {
      //console.log("ready to put  " + this.stringifyValue);
      this.http.put(this.CompanyDocApiPath + "" + this.SelectedDocRecord.id, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            //this.getCompanyDocData();
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }
          });
    }

  }


  async saveContactRecord() {
    this.stringifyValue = JSON.stringify(this.SelectedContactRecord);
    //alert(this.stringifyValue);
    if (this.SelectedContactRecord.id == 0) {
      //console.log("ready to post1  " + this.stringifyValue);
      await this.http.post(this.ContactApiPath, this.stringifyValue, this.bcp.getHttpOptions())
        .toPromise();
    }
    else {
      //console.log("ready to put2  " + this.stringifyValue);
      this.http.put(this.ContactApiPath + "" + this.SelectedContactRecord.id, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            // do nothing
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }
          });
    }
  }


  saveUserProfileRecord() {
    if (this.SelectedUserRecord.id == 0) {
      this.SelectedUserRecord.domainId = this.SelectedContactRecord.domainId;
      this.SelectedUserRecord.loginId = this.SelectedContactRecord.loginId;
      this.SelectedUserRecord.password = "123";
      this.SelectedUserRecord.distinguishedName = this.SelectedContactRecord.loginId;
      this.SelectedUserRecord.vip = "N";
    };
    //this.SelectedUserRecord.fullName = this.SelectedContactRecord.fullName;
    //this.SelectedUserRecord.department = this.SelectedContactRecord.department;
    //this.SelectedUserRecord.title = this.SelectedContactRecord.title;
    //this.SelectedUserRecord.email = this.SelectedContactRecord.email1;
    //this.SelectedUserRecord.phone = this.SelectedContactRecord.phone1;
    this.SelectedUserRecord.alphaName = this.bcp.upper(this.SelectedContactRecord.email1.split('@')[0]);
    this.SelectedUserRecord.companyDomain = this.bcp.upper(this.SelectedContactRecord.email1.split('@')[1]);
    this.SelectedUserRecord.companyCode = this.SelectedContactRecord.companyCode;
    this.SelectedUserRecord.activeFlag = this.SelectedContactRecord.activeFlag;
    if (this.SelectedRecord.companyType == "D") {
      this.SelectedUserRecord.accountType = "DOMAIN"
    } else if (this.SelectedRecord.companyType == "E") {
      this.SelectedUserRecord.accountType = "ENDUSER"
      this.SelectedUserRecord.processRole = "CONTRACTOR"
    }
    this.SelectedUserRecord.userId = this.SelectedUserRecord.loginId;
    this.SelectedUserRecord.updateDate = this.bcp.getCurrentDateTime();
    this.SelectedUserRecord.updateUser = this.bcp.getCurrentLoginUser();

    this.stringifyValue = JSON.stringify(this.SelectedUserRecord);
    //alert(this.stringifyValue);
    if (this.SelectedUserRecord.id == 0) {
      this.http.post(this.UserProfileApiPath, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            //do nothing
          },
          (err) => {

            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }
          });

    }
    else {
      //console.log("ready to put  " + this.stringifyValue);
      this.http.put(this.UserProfileApiPath + "" + this.SelectedUserRecord.id, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            //do nothing
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }

          });

    }

  }


  //Return to Inquiry Form
  saveThenFindRecord() {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to save this record?',
      accept: () => {
        this.uploadAttachment = false;
        this.preProcessingAndSave();
        if (this.loggedInType == 'E' && this.checkedError == 'N') {
          this._router.navigate(['/home/bcpHome']);
        }
      },
      reject: () => {
        //Do Nothing
      }
    });

  }


  addNewDocRow() {
    var blankRow: ICompanyDoc;
    blankRow = null;
    blankRow = JSON.parse('{"id":0}');
    //incement line number by 1
    this.lineNumber = this.lineNumber + 1;
    blankRow.lineNumber = this.lineNumber;
    blankRow.companyDocumentType = "";
    blankRow.companyDocumentName = "";
    blankRow.applicableFlag = "N";
    blankRow.documentNumber = "";
    blankRow.documentExpiryDate = "";
    blankRow.displayName = "";
    blankRow.mandatoryFlag = "N";
    blankRow.id = 0;
    blankRow.attachmentRecordId = 0;
    blankRow.createUser = this.bcp.getCurrentLoginUser();
    blankRow.createDate = this.bcp.getCurrentDateTime();
    //clone the whole array to a tmpArray and add new blank row
    const tmpArray = [...this.DocRecordList];
    tmpArray.push(blankRow);
    this.DocRecordList = tmpArray;
  }


  processCompanyDocTable() {
    //initialize the SelectedDocRecord as a new record
    this.SelectedDocRecord = null;
    this.SelectedDocRecord = JSON.parse('{"id": 0}');
    this.SelectedDocRecord.domainId = this.SelectedRecord.domainId;
    this.SelectedDocRecord.companyCode = this.SelectedRecord.companyCode;
    if (this.DocRecordList.length > 0) {
      this.DocRecordList.forEach(line => {
        if (line.lineNumber > 0 && line.companyDocumentType.trim() != "") {
          this.SelectedDocRecord.id = line.id;
          this.SelectedDocRecord.lineNumber = line.lineNumber;
          this.SelectedDocRecord.companyDocumentType = line.companyDocumentType;
          this.SelectedDocRecord.companyDocumentName = line.companyDocumentName;
          this.SelectedDocRecord.applicableFlag = line.applicableFlag;
          this.SelectedDocRecord.documentNumber = line.documentNumber;
          this.SelectedDocRecord.documentReference = "";
          this.SelectedDocRecord.documentIssueDate = this.bcp.get1900Date();
          this.SelectedDocRecord.documentExpiryDate = line.documentExpiryDate;
          this.SelectedDocRecord.remark = "";
          this.SelectedDocRecord.instructionText = "";
          this.SelectedDocRecord.mandatoryFlag = line.mandatoryFlag;
          this.SelectedDocRecord.displaySequence = 0;
          this.SelectedDocRecord.controlFlag01 = "";
          this.SelectedDocRecord.controlFlag02 = "";
          this.SelectedDocRecord.controlFlag03 = "";
          this.SelectedDocRecord.createUser = line.createUser;
          this.SelectedDocRecord.createDate = line.createDate;
          this.SelectedDocRecord.uploadUser = "";
          this.SelectedDocRecord.uploadDate = this.bcp.get1900Date();
          this.SelectedDocRecord.downloadUser = "";
          this.SelectedDocRecord.downloadDate = this.bcp.get1900Date();
          this.SelectedDocRecord.updateDate = this.bcp.getCurrentDateTime();
          this.SelectedDocRecord.updateUser = this.bcp.getCurrentLoginUser();
          this.saveCompanyDocRecord();
        }
      })
    }

  }


  //delete record is now obsolete because email has been sent automatically when newly created
  deleteCompanyRecords(domainId,companyCode) {
    this.confirmationService.confirm({
      message: 'Do you confirm to delete the selected record  ?',
      accept: () => {
        this.DeleteCompanyFieldHolder = null;
        this.DeleteCompanyFieldHolder = JSON.parse('{"id": 0}');
        this.DeleteCompanyFieldHolder.domainId = domainId;
        this.DeleteCompanyFieldHolder.companyCode = companyCode;
        this.stringifyValue = JSON.stringify(this.DeleteCompanyFieldHolder);
        this.http.post(this.PrimaryApiPath + "DeleteCompanyRecords/", this.stringifyValue, this.bcp.getHttpOptions())
          .subscribe((result: any[]) => {
            //get company data
            this.getDataBySearchField();
          });
      },
      reject: () => {
        //do nothing
      }
    });
  }


  //delete record is now obsolete because email has been sent automatically when newly created
  async deleteRecord(pId,cId,cLoginId) {
    if (window.confirm('Do you confirm to delete the selected record  ?')) {
      //get loginid from contact record
      await this.http.get(this.ContactApiPath + "GetLoginId/" + cId, this.bcp.getHttpOptions())
        .subscribe(
          (data: any) => {
            cLoginId = "";
            cLoginId = data;
          });
      //delete company and then contact and then user profile record if existed
      this.http.delete(this.PrimaryApiPath + pId, this.bcp.getHttpOptions())
        .subscribe(
          (data: any) => {
            this.http.delete(this.ContactApiPath + cId, this.bcp.getHttpOptions())
              .subscribe(
                (data: any) => {
                  this.http.delete(this.UserProfileApiPath + "DeleteByLoginId/" + cLoginId, this.bcp.getHttpOptions())
                    .subscribe(
                      (data: any) => {
                        //do nothing
                      });
                  //find records after delete
                  this.findRecord();
                });
          });
    }
  }


  //delete the company doc record 
  deleteSingleCompanyDoc(recordID) {
    this.confirmationService.confirm({
      message: 'Do you confirm to delete this document line ?',
      accept: () => {
        this.http.delete(this.CompanyDocApiPath + recordID, this.bcp.getHttpOptions()).subscribe((result: any) => {
          this.getCompanyDocData();
        });
      },
      reject: () => {
        //do nothing
      }
    });
  }


  cancel() {
    this.findRecord();
    this.SelectedRecord = null;
    this.SelectedContactRecord = null;
    this.InputErrorMsg = [];

    this.ShowAddForm = false;
    this.ShowEditForm = false;
    this.ShowInquiryForm = true;
    this.ShowDeclarationForm = false;
    this.ShowNotAuthorizedForm = false;
    this.ShowVerificationForm = false;
    this.FormTitle = "Work With Company Profiles";

  }

  //-----------------------------------------------------------------------------
  //                      Fetch List Data for Drop Down List
  //-----------------------------------------------------------------------------

  getDomainList() {
    this.http.get("api/BcpDomain/DomainList", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.DomainList = result;

      });
  }


  //-----------------------------------------------------------------------------
  //                                  Export Data
  //-----------------------------------------------------------------------------

  async generateExcelReport() {
    let companyRec: ICompany;
    let companyList: ICompany[];

    let fileReader = new FileReader();
    let strLine: string;
    let timeStamp: string;
    const url = "https://sheetjs.com/data/executive.json";

    //get the master data
    companyList = this.RecordList;
    timeStamp = this.bcp.convertDateToString(null, true).toString();

    //initial the worksheet and workbook
    //this.strLine = "";
    //this.updateExcelRow();
    let worksheet = XLSX.utils.json_to_sheet(this.excelRow, { header: [""], skipHeader: true });
    let workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Company List");

    //if then else for easy to collapase the contents only
    //Header Fields
    if (1 == 1) {
      //---------------------------------------------
      //List Headings
      //---------------------------------------------
      if (this.FormAccessRight == "RW") {
        this.strLine = "Domain~ Company Type~ Company Code~ Company Number";
        this.strLine = this.strLine + "~ Company Name~ Status~ Registered (Y/N)";
      } else {
        this.strLine = "Company Code~ Company Number";
        this.strLine = this.strLine + "~ Company Name~ Status~ Registered (Y/N)";
      }

      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    }

    //output the record details
    for (var i = 0; i < companyList.length; i++) {

      if (this.FormAccessRight == "RW") {
        this.strLine = "" + companyList[i].domainId
          + "~" + companyList[i].companyType + "~" + companyList[i].companyCode
          + "~" + companyList[i].companyNumber + "~" + companyList[i].fullName
          + "~" + companyList[i].companyStatus + "~" + companyList[i].registerFlag;
      } else {
        this.strLine = "" + ""
          + "~" + "" + "~" + companyList[i].companyCode
          + "~" + companyList[i].companyNumber + "~" + companyList[i].fullName
          + "~" + companyList[i].companyStatus + "~" + companyList[i].registerFlag;
      }

      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    }

    this.fixWidth(worksheet);
    this.applyCellFormat(worksheet);

    XLSX.writeFile(workbook, "CompanyList_" + timeStamp + ".xlsx", { compression: true });
  }

  updateExcelRow() {
    const colIndexArray = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
    let dataArray: string[];
    this.excelRow = [];
    dataArray = this.strLine.split("~");
    //console.log("string is " + dataArray);
    for (let index = 0; index < dataArray.length; index += 1) {
      this.excelRow[index] = dataArray[index];
    }
  }

  //Formet Excel Cell
  fixWidth(worksheet: XLSX.WorkSheet) {
    const data = XLSX.utils.sheet_to_json<any>(worksheet)
    const wscols = [
      { width: 8 }, { width: 14 }, { width: 14 }, { width: 20 }, { width: 20 }, //ABCDE
      { width: 30 }, { width: 30 }, { width: 30 }, { width: 25 }, { width: 10 }, //FGHIJ
      { width: 20 }, { width: 15 }, { width: 20 }, { width: 20 }, { width: 20 }, //KLMNO
      { width: 20 }, { width: 15 }, { width: 15 }, { width: 15 }, { width: 15 }, //PQRST
      { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 } //UVWXYZ
    ];
    worksheet["!cols"] = wscols;

    this.lastRowNumber = data.length + 1;
  }

  applyCellFormat(worksheet: XLSX.WorkSheet) {

    //Format Cell as Bold with Border
    let tmpList = [];
    this.cellList = [];

    //bold
    this.addRangeToCellList("A", 1, "I", 1, true);
    this.formatCell(worksheet, this.cellList, "BOLD");

    //bgcolor
    this.addRangeToCellList("A", 1, "I", 1, true);
    this.formatCell(worksheet, this.cellList, "BGCOLOR_01");

    //border
    tmpList = [];
    this.addRangeToCellList("A", 1, "I", this.lastRowNumber, true);
    this.formatCell(worksheet, this.cellList, "BORDER");

    //amount with 2dp
    //aware if any space before the cell value
    tmpList = ["C5"];
    //this.formatCell(worksheet, this.cellList, "AMOUNT");

    //Number in 2dp
    tmpList = [""];
    //this.addListToCellList(tmpList, false);
    //this.formatCell(worksheet, this.cellList, "NUMBER");

    //percent in 2dp
    tmpList = [""];
    //this.formatCell(worksheet, this.cellList, "PERCENT");

    console.log(this.cellList);
  }

  addRangeToCellList(startCol, startRow, endCol, endRow, appendFlag) {
    let startColIndex = this.charToColIndex(startCol);
    let endColIndex = this.charToColIndex(endCol);
    let currCell: string;
    if (!appendFlag || this.cellList == null || this.cellList == undefined) {
      this.cellList = [];
    }

    for (let c = startColIndex; c <= endColIndex; c++) {
      for (let r = startRow; r <= endRow; r++) {
        this.cellList.push(this.colIndexToChar(c) + r);
      }

    }
  }

  formatCell(worksheet: XLSX.WorkSheet, localCellList: string[]
    , formatRule: string) {

    let defaultStyle = {
      font: {
        bold: false,
        italic: false,
        underline: false
      },
      border: {
        top: { style: "none", color: { auto: 1 } },
        right: { style: "none", color: { auto: 1 } },
        bottom: { style: "none", color: { auto: 1 } },
        left: { style: "none", color: { auto: 1 } }
      }
    };

    let newStyle = JSON.parse(JSON.stringify(defaultStyle));
    let originalStyle = JSON.parse(JSON.stringify(defaultStyle));

    const fontSetting01 = {
      bold: true,
      italic: false,
      underline: false
    };

    const borderSetting01 = {
      top: { style: "thin", color: { auto: 1 } },
      right: { style: "thin", color: { auto: 1 } },
      bottom: { style: "thin", color: { auto: 1 } },
      left: { style: "thin", color: { auto: 1 } }
    };

    const bgcolorSetting01 = {
      patternType: "solid",
      fgColor: { rgb: "e6f7eb" }
    }

    for (let i = 0; i < localCellList.length; i++) {
      //cache the original style of the cell

      if (worksheet[localCellList[i]] !== undefined) {
        if (formatRule === "BOLD" || formatRule === "BORDER"
          || formatRule === "BGCOLOR_01") {
          newStyle = JSON.parse(JSON.stringify(defaultStyle));
          originalStyle = JSON.parse(JSON.stringify(defaultStyle));
          if (worksheet[localCellList[i]].s !== undefined) {
            originalStyle = JSON.parse(JSON.stringify(worksheet[localCellList[i]].s));
          }

          if (originalStyle.font !== undefined) {
            newStyle.font = originalStyle.font;
          }
          if (originalStyle.border !== undefined) {
            newStyle.border = originalStyle.border;
          }
          if (originalStyle.fill !== undefined) {
            newStyle.fill = originalStyle.fill;
          }

          if (formatRule === "BOLD") {
            newStyle.font = fontSetting01;
          }

          if (formatRule === "BORDER") {
            newStyle.border = borderSetting01;
          }

          if (formatRule === "BGCOLOR_01") {
            newStyle.fill = bgcolorSetting01;
          }

          worksheet[localCellList[i]].s = newStyle;
        }

        if (formatRule === "AMOUNT") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "_($* #,##0.00_);_($* (#,##0.00);_($* -??_);_(@_)";
        }

        if (formatRule === "NUMBER") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "0.00";
        }

        if (formatRule === "NUMBER_4DP") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "0.0000";
        }

        if (formatRule === "PERCENT") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "0.00%";
        }
      } else {
        console.log("Error when Formatting Cell " + localCellList[i]);
      }
    }

  }
  //formatCell end

  charToColIndex(colName) {
    let result = 0;
    if (colName.length == 1) {
      result = colName.charCodeAt(0) - 64
    } else {
      result = (colName[0].charCodeAt(0) - 64) * 26;
      result = result + colName[1].charCodeAt(0) - 64;
    }
    return result;
  }

  colIndexToChar(colIndex) {
    let result: string = "";
    let adjustFlag = (colIndex - (Math.floor(colIndex / 26) * 26)) === 0 ? 1 : 0; // for AZ/BZ ... handling

    if (colIndex <= 26) {
      result = String.fromCharCode(colIndex + 64);
    } else {
      result = String.fromCharCode(Math.floor((colIndex - adjustFlag) / 26) + 64); //assume max column is ZZ
      result = result + String.fromCharCode(colIndex - (Math.floor((colIndex - adjustFlag) / 26) * 26) + 64);
    }
    return result;
  }

  //-----------------------------------------------------------------------------
  //                                  Attachment
  //-----------------------------------------------------------------------------

  //set file object for upload when file is selected
  selectUploadFile(event: any) {
    for (let file of event.files) {
      this.uploadFile = file;
    }
  }

  //upload the selected attachment
  processUploadFile(sourceRecordId: any, index: any) {
    //console.log(">>> Uploading file for Key ID = " + sourceRecordId);
    this.SuccessUpload = false;
    this.AttachmentAutoReload = false;
    //save company doc record
    this.SelectedDocRecord = null;
    this.SelectedDocRecord = JSON.parse('{"id": 0}');
    this.SelectedDocRecord.id = this.DocRecordList[index].id;
    this.SelectedDocRecord.domainId = this.SelectedRecord.domainId;
    this.SelectedDocRecord.companyCode = this.SelectedRecord.companyCode;
    this.SelectedDocRecord.lineNumber = this.DocRecordList[index].lineNumber;
    this.SelectedDocRecord.companyDocumentType = this.DocRecordList[index].companyDocumentType;
    this.SelectedDocRecord.companyDocumentName = this.DocRecordList[index].companyDocumentName;
    this.SelectedDocRecord.applicableFlag = this.DocRecordList[index].applicableFlag;
    this.SelectedDocRecord.documentNumber = this.DocRecordList[index].documentNumber;
    this.SelectedDocRecord.documentReference = "";
    this.SelectedDocRecord.documentIssueDate = this.bcp.get1900Date();
    this.SelectedDocRecord.documentExpiryDate = this.DocRecordList[index].documentExpiryDate;
    this.SelectedDocRecord.remark = "";
    this.SelectedDocRecord.instructionText = "";
    this.SelectedDocRecord.mandatoryFlag = this.DocRecordList[index].mandatoryFlag;
    this.SelectedDocRecord.displaySequence = 0;
    this.SelectedDocRecord.controlFlag01 = "";
    this.SelectedDocRecord.controlFlag02 = "";
    this.SelectedDocRecord.controlFlag03 = "";
    this.SelectedDocRecord.createUser = this.DocRecordList[index].createUser;
    this.SelectedDocRecord.createDate = this.DocRecordList[index].createDate;
    this.SelectedDocRecord.uploadUser = this.bcp.getCurrentLoginUser();
    this.SelectedDocRecord.uploadDate = this.bcp.getCurrentDateTime();
    this.SelectedDocRecord.downloadUser = "";
    this.SelectedDocRecord.downloadDate = this.bcp.get1900Date();
    this.SelectedDocRecord.updateDate = this.SelectedDocRecord.uploadDate;
    this.SelectedDocRecord.updateUser = this.SelectedDocRecord.uploadUser;
    this.saveCompanyDocRecord();

    if (this.uploadFile) {
      var filePrefix: String;
      filePrefix = "BCP_ID" + ("0000000000" + sourceRecordId).substr(-10);
      filePrefix = filePrefix + "_" + this.bcp.convertDateToString() + "_";

      let fileToUpload = this.uploadFile;
      let formData: FormData = new FormData();

      formData.append(fileToUpload.name, fileToUpload, filePrefix + fileToUpload.name);
      formData.append("DomainId", this.bcp.getCurrentDomainId());
      formData.append("SourceTableName", "BcpCompanyDoc");
      formData.append("SourceRecordId", sourceRecordId);
      formData.append("UpdateUser", this.bcp.getCurrentLoginUser());

      let headers = new HttpHeaders();
      // DON'T SET THE Content-Type to multipart/form-data,
      //You'll get the Missing content-type boundary error
      //let options = new RequestOptions();

      this.http.post(this.AttachmentApiPath + "UploadFile/"+ sourceRecordId, formData, this.bcp.getHttpOptionsAtt())
        .subscribe((r : any)=> {
          var result = JSON.parse(r);
          //this.uploadFile = null;
          if (result.message == "succeed") {
            this.SuccessUpload = true;
            this.DocRecordList[index].displayName = fileToUpload.name;
            //this.getCompanyDocData();
            this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'File uploaded successfully' }];
            this.DocRecordList[index].attachmentRecordId = result.newAttachmentId;
          } else {
            this.resultMsgs = [{ severity: 'info', summary: 'Rejected', detail: result.message }];
          }

        });
    }

  }

  //download attachment by click on the filename

  downloadFile(recordID, fileName) {

    //this.http.get(this.AttachmentPath + "File/" + recordID, { 'responseType': 'blob'} )
    this.http.get(this.AttachmentApiPath + "DownloadFile/" + recordID, this.bcp.getHttpOptionsAtt("blob"))
      .catch((err) => { return Observable.throw(err); })
      .subscribe((result: HttpResponse<Blob>)=> {
        //var returnFilename = this.bcp.getFilenameFromHttpResponse(result.headers.get('content-disposition'));
        const contentType = result.headers.get('content-type');
        const blob = new Blob([result.body], { type: contentType });
        const url = URL.createObjectURL(blob);
        if (navigator.vendor.toUpperCase().indexOf("APPLE") !== -1) {
          //safari handling
          const a = document.createElement('a');
          a.href = url;
          a.target = '_blank'; //open in new tab
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url); // Clean up the URL object
        } else {
          // For other browsers (Chrome, Firefox, etc.)
          if (window.navigator.msSaveOrOpenBlob) {
            const blob = new Blob([result.body], { type: contentType });
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            const blob = new Blob([result.body], { type: contentType });
            const fileURL = URL.createObjectURL(blob);
            window.open(fileURL, '_blank'); // Open in a new tab

          }
        }
        //if (window.navigator.msSaveOrOpenBlob) { // for IE and Edge
        //  const blob = new Blob([result.body], { type: contentType });
        //  window.navigator.msSaveOrOpenBlob(blob, fileName);
        //} else {
        //  const blob = new Blob([result.body], { type: contentType });
        //  const fileURL = URL.createObjectURL(blob);
        //  window.open(fileURL, '_blank'); // Open in a new tab
        //}
     })
            
  }
  

  //delete the attachment 
  deleteAttachment(recordID, index) {
    this.confirmationService.confirm({
      message: 'Do you confirm to delete the selected record?',
      accept: () => {
        this.http.delete(this.AttachmentApiPath + "DeleteFile/" + recordID, this.bcp.getHttpOptions()).subscribe((result: any) => {
          this.DocRecordList[index].documentNumber = "";
          this.DocRecordList[index].documentExpiryDate = "";
          //save company doc record
          this.SelectedDocRecord = null;
          this.SelectedDocRecord = JSON.parse('{"id": 0}');
          this.SelectedDocRecord.id = this.DocRecordList[index].id;
          this.SelectedDocRecord.domainId = this.SelectedRecord.domainId;
          this.SelectedDocRecord.companyCode = this.SelectedRecord.companyCode;
          this.SelectedDocRecord.lineNumber = this.DocRecordList[index].lineNumber;
          this.SelectedDocRecord.companyDocumentType = this.DocRecordList[index].companyDocumentType;
          this.SelectedDocRecord.companyDocumentName = this.DocRecordList[index].companyDocumentName;
          this.SelectedDocRecord.applicableFlag = this.DocRecordList[index].applicableFlag;
          this.SelectedDocRecord.documentNumber = this.DocRecordList[index].documentNumber;
          this.SelectedDocRecord.documentReference = "";
          this.SelectedDocRecord.documentIssueDate = this.bcp.get1900Date();
          this.SelectedDocRecord.documentExpiryDate = this.DocRecordList[index].documentExpiryDate;
          this.SelectedDocRecord.remark = "";
          this.SelectedDocRecord.instructionText = "";
          this.SelectedDocRecord.mandatoryFlag = this.DocRecordList[index].mandatoryFlag;
          this.SelectedDocRecord.displaySequence = 0;
          this.SelectedDocRecord.controlFlag01 = "";
          this.SelectedDocRecord.controlFlag02 = "";
          this.SelectedDocRecord.controlFlag03 = "";
          this.SelectedDocRecord.createUser = this.DocRecordList[index].createUser;
          this.SelectedDocRecord.createDate = this.DocRecordList[index].createDate;
          this.SelectedDocRecord.uploadUser = "";
          this.SelectedDocRecord.uploadDate = this.bcp.get1900Date();
          this.SelectedDocRecord.downloadUser = "";
          this.SelectedDocRecord.downloadDate = this.bcp.get1900Date();
          this.SelectedDocRecord.updateDate = this.bcp.getCurrentDateTime();
          this.SelectedDocRecord.updateUser = this.bcp.getCurrentLoginUser();
          this.saveCompanyDocRecord();
          //refresh table
          this.getCompanyDocData();
        });
      },
      reject: () => {
        //Do Nothing
      }
    });
  }


  //Re-direct from add page to edit page to upload attachment
  saveThenUploadAttachment() {
    this.uploadAttachment = true;
    this.saveRecord()
  }

  //to get attachment list
  getAttachmentList(recordID) {
    this.AttachmentList = [];
    this.http.get(this.AttachmentApiPath + "List/" + this.bcp.getCurrentDomainId() + "/Company/" + recordID, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.AttachmentList = result;
        //console.log("aatachment " + this.AttachmentList);
        if (this.AttachmentList.length > 0) {
          this.AttachmentAutoReload = true;
        }
      });
  }

  //sorting event trigger, default is sorting by id
  changeSort(event) {
        if (!event.order) {
            this.sortF = 'id';
        } else {
            this.sortF = event.field;
        }
    }


  selectDoc(pNewStatus: string) {
    var applicableFlagValue = "Y";
    this.InputErrorMsg = [];
    if (pNewStatus.match("X")) {
      applicableFlagValue = "N";
    }
    //remove all properties in the object except of id and applicableFlag
    this.SelectedDocRecordList.forEach(function (x) {
      x.applicableFlag = applicableFlagValue;
      Object.keys(x).forEach(key => {
        if (key.toLowerCase() != 'id' && key.toLowerCase() != 'applicableflag') {
          delete x[key]
        }
      }
      );
    });
    this.stringifyValue = JSON.stringify(this.SelectedDocRecordList);
    console.log("SelectedDocList is " + this.stringifyValue);
    this.http.post(this.CompanyDocApiPath + "UpdateApplicableFlag/", this.stringifyValue, this.bcp.getHttpOptions())
      .subscribe(
        (result: any) => {
          this.getCompanyDocData();
          this.SelectedDocRecordList = null;
        },
        (err) => {
          if (err.status === 400) {
            // handle validation error
            let validationErrorDictionary = JSON.parse(err.text());
            for (var fieldName in validationErrorDictionary) {
              if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
              }
            }
          } else {
            this.InputErrorMsg.push("something went wrong!");
          }
        });

  }



  //-----------------------------------------------------------------------------
  //                      Email Functions
  //-----------------------------------------------------------------------------

  sendInviteRegistrationEmail() {
    this.companyRegistrationEmail = {};
    this.companyRegistrationEmail.loginDomain = this.bcp.getCurrentDomainId();
    this.companyRegistrationEmail.loginUser = this.bcp.getCurrentLoginUser();
    this.companyRegistrationEmail.companyCode = this.SelectedRecord.companyCode;
    this.companyRegistrationEmail.companyName = this.SelectedRecord.fullName;
    this.companyRegistrationEmail.email = this.SelectedContactRecord.email1;
    this.companyRegistrationEmail.verificationKey = this.SelectedRecord.vertificationKey;
    this.stringifyValue = "";
    this.stringifyValue = JSON.stringify(this.companyRegistrationEmail);

    this.emailReturnStatus = false;

    this.http.post(this.SendEmailPath + "SendInviteRegistrationEmail", this.stringifyValue, this.bcp.getHttpOptions())
      .subscribe((result: any) => {
        this.emailReturnStatus = true;
        this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Email had been sent out to contractor user' }];
      },
        (err) => {
          this.emailReturnStatus = false;
          this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Failed to sent out email to contractor user' }];
        });
  }


  sendCompleteRegistrationEmail() {
    this.companyRegistrationEmail = {};
    this.companyRegistrationEmail.loginDomain = this.bcp.getCurrentDomainId();
    this.companyRegistrationEmail.loginUser = this.SelectedRecord.createUser;
    this.companyRegistrationEmail.companyCode = this.SelectedRecord.companyCode;
    this.companyRegistrationEmail.companyName = this.SelectedRecord.fullName;
    this.companyRegistrationEmail.email = "";
    this.companyRegistrationEmail.verificationKey = "";
    this.stringifyValue = "";
    this.stringifyValue = JSON.stringify(this.companyRegistrationEmail);

    this.emailReturnStatus = false;

    this.http.post(this.SendEmailPath + "SendCompleteRegistrationEmail", this.stringifyValue, this.bcp.getHttpOptions())
      .subscribe((result: any) => {
        this.emailReturnStatus = true;
        this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Email had been sent out to create user' }];
      },
        (err) => {
          this.emailReturnStatus = false;
          this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Failed to sent out email to create user' }];
        });
  }


  sendApproveRegistrationEmail() {
    this.companyRegistrationEmail = {};
    this.companyRegistrationEmail.loginDomain = this.bcp.getCurrentDomainId();
    this.companyRegistrationEmail.loginUser = this.bcp.getCurrentLoginUser();
    this.companyRegistrationEmail.companyCode = this.SelectedRecord.companyCode;
    this.companyRegistrationEmail.companyName = this.SelectedRecord.fullName;
    this.companyRegistrationEmail.email = this.SelectedContactRecord.email1;
    this.companyRegistrationEmail.verificationKey = "";
    this.stringifyValue = "";
    this.stringifyValue = JSON.stringify(this.companyRegistrationEmail);

    this.emailReturnStatus = false;

    this.http.post(this.SendEmailPath + "SendApproveRegistrationEmail", this.stringifyValue, this.bcp.getHttpOptions())
      .subscribe((result: any) => {
        this.emailReturnStatus = true;
        this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Email had been sent out to contractor user' }];
      },
        (err) => {
          this.emailReturnStatus = false;
          this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Failed to sent out email to contractor user' }];
        });
  }

  //-----------------------------------------------------------------------------
  //                      Checking/ Other Actions
  //-----------------------------------------------------------------------------

  clearAllMessage() {
    this.InputErrorMsg = [];
    this.resultMsgs = [];

  }


  isValidEmail(email: string): boolean {
    const emailPattern = /^[a-zA-Z0-9,_%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  }

  //perform validation and then generate default and then save
  async preProcessingAndSave() {

    //clear error message
    this.clearAllMessage();
    this.checkedError = 'N';

    //check domain
    if (this.SelectedRecord.domainId.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Domain is missing   ' });
    };

    //check company name
    if (this.SelectedRecord.fullName.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Company Name is missing   ' });
    };

    //check email input
    if (this.SelectedContactRecord.email1.trim() == "" || this.bcp.upper(this.SelectedContactRecord.email1) != this.bcp.upper(this.confirmEmail)
      || !this.isValidEmail(this.SelectedContactRecord.email1)) {
      //this.SelectedContactRecord.email1.includes("@"))
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Email is missing / not valid   ' });
    }

    //check contact name
    if (this.SelectedContactRecord.fullName.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Contact Name is missing   ' });
    };

    //check address line and contact name and phone for supplier performing registration
    if (this.loggedInType == "E") {
      if (this.SelectedRecord.companyStatus == "OPEN") {
        this.doingRegistration = true;
        this.SelectedRecord.registerFlag = "Y";
        this.SelectedRecord.companyStatus = "PENDING";
        this.SelectedRecord.registerUser = this.bcp.getCurrentLoginUser();
        this.SelectedRecord.registerDate = this.bcp.getCurrentDateTime();
      };
      //check address line
      if (this.SelectedRecord.addressLine1.trim() == "" && this.SelectedRecord.addressLine2.trim() == "" && this.SelectedRecord.addressLine3.trim() == "" && this.SelectedRecord.addressLine4.trim() == "") {
        this.checkedError = 'Y';
        this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Address line is missing   ' });
      };
      //check phone number
      if (this.SelectedContactRecord.phone1.trim() == "") {
        this.checkedError = 'Y';
        this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Phone Number is missing   ' });
      };
    };

    //check company doc for supplier user
    if (this.loggedInType == 'E' && this.DocRecordList.length > 0) {
      this.DocRecordList.forEach(line => {
        if (line.mandatoryFlag == 'Y' && this.checkedError == "N") {
          if (line.documentNumber.trim() == "" || line.documentExpiryDate == "" || line.displayName.trim() == "") {
            this.checkedError = 'Y';
            this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Document for BR & ECI must be uploaded and input   ' });
          }
        }
      })
    }

    //assign default and check unique if above checking passed
    if (this.checkedError == 'N') {
      if (this.SelectedRecord.companyType != "E") {
        this.SelectedRecord.companyStatus = "ACTIVE";
        this.SelectedRecord.inviteFlag = "Y";
        this.SelectedRecord.registerFlag = "Y";
        this.SelectedRecord.registerUser = this.bcp.getCurrentLoginUser();
        this.SelectedRecord.registerDate = this.bcp.getCurrentDateTime();
        this.SelectedRecord.inviteUser = this.SelectedRecord.registerUser;
        this.SelectedRecord.inviteDate = this.SelectedRecord.registerDate;
        this.SelectedRecord.approveUser = this.SelectedRecord.registerUser;
        this.SelectedRecord.approveDate = this.SelectedRecord.registerDate;
      }
      //generate new company code if leave blank
      if (this.SelectedRecord.companyCode.trim() == "") {
        await this.genNextNumber(this.SelectedRecord.domainId, 'CO01', '');
        this.SelectedRecord.companyCode = this.NextNumberOutput.nextKey;
      };
      this.SelectedRecord.companyCode = this.bcp.upper(this.SelectedRecord.companyCode);
      this.SelectedRecord.updateUser = this.bcp.getCurrentLoginUser();
      this.SelectedRecord.updateDate = this.bcp.getCurrentDateTime();
      this.SelectedRecord.fullNameCompress = this.bcp.upper(this.SelectedRecord.fullName.split(" ").join(""));
      this.SelectedRecord.tempCompany = this.bcp.convertBooleanToYesNo(this.SelectedRecord.tempCompany);
      //get new loginId for contact record
      if (this.SelectedRecord.id == 0) {
        if (this.SelectedRecord.companyType == "D") {
          await this.genNextNumber(this.SelectedRecord.domainId, 'UP02', '');
          this.SelectedUserRecord.loginId = this.NextNumberOutput.nextKey;
        } else if (this.SelectedRecord.companyType == "E") {
          await this.genNextNumber(this.SelectedRecord.domainId, 'UP03', '');
          this.SelectedUserRecord.loginId = this.NextNumberOutput.nextKey;
        }
        if (this.NextNumberOutput.nextKey == "NOT_FOUND") {
          this.checkedError = 'Y';
          this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Default Next Number is not setup   ' });
        } else if (this.NextNumberOutput.nextKey == "MAX_NUMBER") {
          this.checkedError = 'Y';
          this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Maximum Next Number is reached   ' });
        } else {
          this.SelectedContactRecord.domainId = this.bcp.upper(this.SelectedRecord.domainId);
          this.SelectedContactRecord.companyCode = this.bcp.upper(this.SelectedRecord.companyCode);
          this.SelectedContactRecord.loginId = this.SelectedUserRecord.loginId;
          this.SelectedContactRecord.activeFlag = "Y";
          //this.SelectedContactRecord.contactId = this.bcp.upper(this.SelectedContactRecord.email1);
          this.SelectedContactRecord.contactId = this.SelectedUserRecord.loginId;
          this.SelectedContactRecord.userAccountType = this.SelectedRecord.companyType;
          this.SelectedContactRecord.primaryContact = "P";
        }
      }
      this.SelectedContactRecord.updateUser = this.bcp.getCurrentLoginUser();
      this.SelectedContactRecord.updateDate = this.bcp.getCurrentDateTime();
      this.SelectedContactRecord.conflictOfInterest = this.bcp.convertBooleanToYesNo(this.SelectedContactRecord.conflictOfInterest);
      this.SelectedContactRecord.needUserAccount = this.bcp.convertBooleanToYesNo(this.SelectedContactRecord.needUserAccount);
    }

    //check unique if above checking passed
    if (this.checkedError == 'N') {
      //check (company code or full name) unique
      let tmpApiString1: string = "";
      tmpApiString1 = JSON.stringify(this.SelectedRecord);
      let checkResult1 = await this.http.post(this.PrimaryApiPath + "ValidateKeyFields/", tmpApiString1, this.bcp.getHttpOptions())
        .map((response: any) => JSON.parse(response.toString())).toPromise();
      if (checkResult1.validFlag == "N") {
        this.checkedError = 'Y';
        this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Company Code is duplicated   ' });
      }
      if (checkResult1.nameValid == "N") {
        this.checkedError = 'Y';
        this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Company Name is duplicated   ' });
      }
      //check new (contact id or email) unique
      let tmpApiString2: string = "";
      tmpApiString2 = JSON.stringify(this.SelectedContactRecord);
      //console.log("temApiString is " + tmpApiString2);
      let checkResult2 = await this.http.post(this.ContactApiPath + "ValidateKeyFields/", tmpApiString2, this.bcp.getHttpOptions())
        .map((response: any) => JSON.parse(response.toString())).toPromise();
      if (checkResult2.validFlag == "N") {
        this.checkedError = 'Y';
        this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'ContactId is duplicated   ' });
      }
      if (checkResult2.EmailFlag == "N") {
        this.checkedError = 'Y';
        this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Email is duplicated   ' });
      }
    };

    //save record finally if no error
    if (this.checkedError == 'N') {
      this.saveRecord();
    };
  }


  //generate new vertification key
  keyGen(len) {
    var newKey = "";
    var charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for (var i = 0; i < len; i++)
      newKey += charset.charAt(Math.floor(Math.random() * charset.length));
    this.SelectedRecord.vertificationKey = newKey;
  }


  //getNextNumber for new contact record
  async genNextNumber(domainId: string, tableKey: string, inputDate: any) {
    this.NextNumberOutput = null;
    this.NextNumberOutput = JSON.parse('{"id": 0}');
    this.GenNextNumberFieldHolder = null;
    this.GenNextNumberFieldHolder = JSON.parse('{"id": 0}');
    this.GenNextNumberFieldHolder.domainId = domainId;
    this.GenNextNumberFieldHolder.tableKey = tableKey;
    this.GenNextNumberFieldHolder.inputDate = inputDate;
    this.GenNextNumberFieldHolder.updateUser = this.bcp.getCurrentLoginUser();
    this.GenNextNumberFieldHolder.updateDate = this.bcp.getCurrentDateTime();
    this.stringifyValue = JSON.stringify(this.GenNextNumberFieldHolder);
    this.NextNumberOutput = await this.http.post(this.TableSequenceApiPath + "GenNextNumber/", this.stringifyValue, this.bcp.getHttpOptions())
      .map((response: any) => JSON.parse(response.toString())).toPromise();
        //console.log("NextNumberOutput is " + this.NextNumberOutput);
        //console.log("nextKey is " + this.NextNumberOutput.nextKey);
  }


  //this function became obsolete since combination of save & invite button
  inviteSupplier() {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to invite this contractor?',
      accept: async () => {
        this.SelectedRecord.inviteFlag = "Y";
        this.SelectedRecord.inviteUser = this.bcp.getCurrentLoginUser();
        this.SelectedRecord.inviteDate = this.bcp.getCurrentDateTime();
        this.preProcessingAndSave();
        //send email to supplier
        let checkResult = await this.http.get(this.SecurityApiPath + "CheckApplyEmail/" + this.bcp.getCurrentDomainId() + "/COM1", this.bcp.getHttpOptions())
          .map((response: any) => JSON.parse(response.toString())).toPromise();
        if (checkResult.applyEmail == "Y") {
          if (this.SelectedRecord.tempCompany == "Y"
            || this.SelectedRecord.tempCompany == true) {
            console.log("prepare to send temp email");
            //this.sendTempCompanyEmail();
          } else {
            console.log("prepare to send normal email");
            this.sendInviteRegistrationEmail();
          }
        }
      },
      reject: () => {
        //do nothing
      }
    });
  }


  //change company status
  changeStatus(status: string) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to change the status?',
      accept: async () => {
        if (status == "APPROVE") {
          status = "ACTIVE"
          this.SelectedRecord.approveUser = this.bcp.getCurrentLoginUser();
          this.SelectedRecord.approveDate = this.bcp.getCurrentDateTime();
          //send email to create user
          let checkResult = await this.http.get(this.SecurityApiPath + "CheckApplyEmail/" + this.bcp.getCurrentDomainId() + "/COM6", this.bcp.getHttpOptions())
            .map((response: any) => JSON.parse(response.toString())).toPromise();
          if (checkResult.applyEmail == "Y") {
            this.sendApproveRegistrationEmail();
          }
        }
        this.SelectedRecord.companyStatus = status;
        //console.log('Status ' + this.SelectedRecord.companyStatus);
        this.preProcessingAndSave();
        //this.saveRecord();
      },
      reject: () => {
        //do nothing
      }
    });
  }
  
  testApprovalAction() {
    var serviceInput: IDialogApprovalAction;
    var serviceOutput: IReturnDialogApprovalAction;

    serviceInput = JSON.parse('{"id": 0}');
    serviceInput.domainId = "TSML";
    serviceInput.actionCode = "COM1";
    serviceInput.approveData = "C1001";
    serviceInput.requestDate = this.bcp.getCurrentDateTime();
    serviceInput.routeCode = "0";
    serviceInput.approveLevel = "0";

    serviceOutput = null;
    this.bcpApprovalAction.openDialog(serviceInput)
      .subscribe(res => {
        serviceOutput = JSON.parse(JSON.stringify(res));
        console.log("getting output from approval action");
        console.log(serviceOutput);
      }
      );
  }

  testApprovalRoute() {
    var serviceInput: IDialogApprovalRoute;
    var serviceOutput: IReturnDialogApprovalRoute;

    serviceInput = JSON.parse('{"id": 0}');
    serviceInput.domainId = "TSML";
    serviceInput.actionCode = "COM1";
    serviceInput.approveData = "C1001";
    serviceInput.requestDate = this.bcp.getCurrentDateTime();
    serviceInput.routeCode = "0";
    serviceInput.maxApproveLevel = "2";
    serviceInput.copyPreviousApprover = "Y";
    serviceInput.defaultApprover = "0";

    serviceOutput = null;
    this.bcpApprovalRoute.openDialog(serviceInput)
      .subscribe(res => {
        serviceOutput = JSON.parse(JSON.stringify(res));
        console.log("getting output from approval route");
        console.log(serviceOutput);
      }
      );
  }

  //Go to Verification Form
  acceptDeclaration() {
    if (this.AcceptDeclaration) {
      if (this.currentRegisterFlag=="Y") {
        this.getIDbyData(this.bcp.getCurrentDomainId(), this.loggedInCompanyCode);
      } else {
        this.ShowVerificationForm = true;
        this.ShowDeclarationForm = false;
        this.ShowNotAuthorizedForm = false;
        this.ShowInquiryForm = false;
        this.ShowAddForm = false;
        this.ShowEditForm = false;
        this.FormTitle = "Contractor Verification";
      };
    }
  }


  //Go to Edit Form after verified
  checkVertification() {
    //Clear Search Form Error Message
    this.clearAllMessage();

    this.checkedError = 'N';
    //check vertification key
    if (this.inputVerificationKey.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Key field should not be null   ' });
    } else {
      if (this.bcp.upper(this.inputVerificationKey) != this.currentVertificationKey) {
        this.checkedError = 'Y';
        this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Entered key does not match   ' });
      }
    };

    //edit record if no error
    if (this.checkedError == 'N') {
      this.getIDbyData(this.bcp.getCurrentDomainId(), this.loggedInCompanyCode);
    };

  }

}

//declare global {
  //interface Navigator {
    //msSaveOrOpenBlob?: (blob: any, defaultName?: string) => boolean;
  //}
//}


interface ICompany {
  id?;
  domainId?;
  companyCode?;
  fullName?;
  fullNameOther?;
  fullNameCompress?;
  companyNumber?;
  companyCodeOther?;
  companyType?;
  companyStatus?;
  businessUnit?;
  vertificationKey?;
  inviteFlag?;
  registerFlag?;
  tempCompany?;
  typeOfBusiness?;
  addressLine1?;
  addressLine2?;
  addressLine3?;
  addressLine4?;
  postalCode?;
  country?;
  typeOfOwnership?;
  phoneArea1?;
  phone1?;
  phoneArea2?;
  phone2?;
  phoneArea3?;
  phone3?;
  phoneArea4?;
  phone4?;
  companyUrl?;
  companyDomain?;
  primaryContactId?;
  maxUsers?;
  conflictOfInterest?;
  conflictFullName?;
  conflictDepartment?;
  conflictRelationship?;
  remark?;
  controlFlag01?;
  controlFlag02?;
  controlFlag03?;
  fiscalDatePattern?;
  currentYearGL;
  currentPeriodGL;
  currentYearAR;
  currentPeriodAR;
  currentYearAP;
  currentPeriodAP;
  createUser?;
  createDate?;
  inviteUser?;
  inviteDate?;
  registerUser?;
  registerDate?;
  approveUser?;
  approveDate?;
  updateDate?;
  updateUser?;
}

interface ICompanyDoc {
  id?;
  domainId?;
  companyCode?;
  lineNumber?;
  companyDocumentType?;
  companyDocumentName?;
  applicableFlag?;
  documentNumber?;
  documentReference?;
  documentIssueDate?;
  documentExpiryDate?;
  remark?;
  instructionText?;
  mandatoryFlag?;
  displaySequence?;
  controlFlag01?;
  controlFlag02?;
  controlFlag03?;
  createUser?;
  createDate?;
  uploadUser?;
  uploadDate?;
  downloadUser?;
  downloadDate?;
  updateDate?;
  updateUser?;
  // not database field
  actualFileName?;
  displayName?;
  attachmentRecordId?;
}

interface IContact {
  id?;
  domainId?;
  contactId?;
  companyCode?;
  fullName?;
  fullNameOther?;
  businessUnit?;
  title?;
  department?;
  addressLine1?;
  addressLine2?;
  addressLine3?;
  addressLine4?;
  postalCode?;
  country?;
  email1?;
  email2?;
  phoneArea1?;
  phone1?;
  phoneArea2?;
  phone2?;
  phoneArea3?;
  phone3?;
  phoneArea4?;
  phone4?;
  contactType?;
  needUserAccount?;
  userAccountType?;
  activeFlag?;
  primaryContact?;
  loginId?;
  conflictOfInterest?;
  conflictFullName?;
  conflictDepartment?;
  conflictRelationship?;
  createUser?;
  createDate?;
  updateDate?;
  updateUser?;
}

interface IUserProfile {
  id?;
  domainId?;
  loginId?;
  password?;
  distinguishedName?;
  fullName?;
  department?;
  title?;
  email?;
  phone?;
  vip?;
  processRole?;
  dataRole?;
  actionRole?;
  alphaName?;
  errorAttempt?;
  businessUnit?;
  controlFlag01?;
  controlFlag02?;
  controlFlag03?;
  companyCode?;
  companyDomain?;
  userId?;
  accountType?;
  staffNumber?;
  company?;
  team?;
  grading?;
  jdeAn81?;
  jdeAn82?;
  jdeAn83?;
  jdeAn84?;
  verifyCode?;
  activeFlag?;
  createUser?;
  createDate?;
  updateUser?;
  updateDate?;

}

interface IDataRole {
}

interface IProcessRole {
}

interface IListValue {
  label?;
  value?;
}

interface IAttachmentValue {
  filePath?;
  id?;
  domainId?;
  sourceTable?;
  sourceRecordId?;
  actualFileName?;
  displayName?;
  createDate?;
  updateUser?;
  updateDate?;
}

interface SelectItem {
}

interface Message {
}

interface IDomainValue {
  label?;
  value?;
}

interface ICompanyRegistrationEmail {
  loginDomain?;
  loginUser?;
  companyCode?;
  companyName?;
  email?;
  verificationKey?;
}

interface ICompanyDocData {
  companyDocumentType?;
  companyDocumentName?;

}

interface IGenNextNumber {
  domainId?;
  tableKey?;
  year?;
  inputDate?;
  updateUser?;
  updateDate?;
}

interface INextNumber {
  nextNumber?;
  nextKey?;
}

interface ICopyCompanyDoc {
  domainId?;
  fromCompanyCode?;
  toCompanyCode?;
  createUser?;
  createDate?;
}

interface IDeleteCompany {
  domainId?;
  companyCode?;
}

interface ICompanyStatus {
  vertificationKey?;
  registerFlag?;
  inviteFlag?;
  tempCompany?;
  companyStatus?;
}



